import React, {useEffect, useState} from "react";
import {Button, InputNumber, Select, Space} from "antd";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";

// «График рассрочки» as rows «месяц.год — сумма» (the staff, 27.10: ECI old's one line is «дико неудобно»); the value
// stays ECI old's line «MM.YYYY-сумма,MM.YYYY-сумма», which its list, its check and the first payment read

const MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((m) => ({value: m, label: m}))
const yearOptions = () => {
  const now = new Date().getFullYear()
  return Array.from({length: 16}, (_, i) => String(now - 3 + i)).map((y) => ({value: y, label: y}))
}

// a part ECI old could not have written stays as it is (raw), so nothing is lost by opening the form
export const parseSchedule = (text) => String(text || '').split(',').map((part) => part.trim()).filter(Boolean).map((part) => {
  const m = /^(\d{1,2})\.(\d{4})-(\d+)$/.exec(part.replace(/\s/g, ''))
  return m ? {month: m[1].padStart(2, '0'), year: m[2], sum: Number(m[3])} : {raw: part}
})
export const scheduleTotal = (text) => parseSchedule(text).reduce((sum, row) => sum + (Number(row.sum) || 0), 0)
const lineOf = (rows) => rows
  .map((row) => (row.raw ? row.raw : row.month && row.year && row.sum ? `${row.month}.${row.year}-${row.sum}` : null))
  .filter(Boolean).join(',')

const groupDigits = (value) => (value === null || value === undefined || value === '' ? '' : String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' '))

export const InstallmentSchedule = ({value, onChange, disabled}) => {
  const [rows, setRows] = useState(() => parseSchedule(value))
  // rows being filled in stay while the value (only whole rows) comes back
  useEffect(() => {
    if (lineOf(rows) !== (value || '')) setRows(parseSchedule(value))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  const update = (next) => {
    setRows(next)
    onChange(lineOf(next) || null)
  }
  const change = (i, patch) => update(rows.map((row, j) => (j === i ? {...row, ...patch} : row)))
  const years = yearOptions()
  return (
    <div className='schedule'>
      {rows.map((row, i) => (
        <Space key={i} className='schedule__row' align='center'>
          {row.raw
            ? <span className='cell-hint'>Не по формату старого сайта: {row.raw}</span>
            : (
              <>
                <Select size='small' style={{width: 72}} placeholder='мес.' options={MONTHS} value={row.month} disabled={disabled}
                  onChange={(month) => change(i, {month})}/>
                <Select size='small' style={{width: 86}} placeholder='год' options={years} value={row.year} disabled={disabled}
                  onChange={(year) => change(i, {year})}/>
                <InputNumber size='small' style={{width: 160}} min={0} precision={0} placeholder='сумма, ₽' value={row.sum} disabled={disabled}
                  formatter={groupDigits} parser={(text) => String(text || '').replace(/\D/g, '')}
                  onChange={(sum) => change(i, {sum})}/>
              </>
            )}
          {!disabled && <Button size='small' type='text' danger icon={<DeleteOutlined/>} aria-label='Убрать платёж'
            onClick={() => update(rows.filter((_, j) => j !== i))}/>}
        </Space>
      ))}
      {!disabled && (
        <Button size='small' icon={<PlusOutlined/>} onClick={() => setRows([...rows, {month: undefined, year: undefined, sum: null}])}>
          Добавить платёж
        </Button>
      )}
    </div>
  )
}
